var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ibox-content" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.nombre,
                      expression: "especialidad_json.nombre",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre", readonly: "", type: "text" },
                  domProps: { value: _vm.especialidad_json.nombre },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "nombre",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Código de integración")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.UUID,
                      expression: "especialidad_json.UUID",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "Código de integración",
                    readonly: "readonly",
                    type: "text",
                  },
                  domProps: { value: _vm.especialidad_json.UUID },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "UUID",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.confirmable,
                      expression: "especialidad_json.confirmable",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: { type: "checkbox", "data-switchery": "true" },
                  domProps: {
                    checked: Array.isArray(_vm.especialidad_json.confirmable)
                      ? _vm._i(_vm.especialidad_json.confirmable, null) > -1
                      : _vm.especialidad_json.confirmable,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.especialidad_json.confirmable,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.especialidad_json,
                              "confirmable",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.especialidad_json,
                              "confirmable",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.especialidad_json, "confirmable", $$c)
                      }
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre Corto")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.nombre_corto,
                      expression: "especialidad_json.nombre_corto",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre Corto", type: "text" },
                  domProps: { value: _vm.especialidad_json.nombre_corto },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "nombre_corto",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Anulación hora telemedicina")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.anulacion_hora_tlm,
                      expression: "especialidad_json.anulacion_hora_tlm",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "Hora anulación telemedicina",
                    type: "text",
                  },
                  domProps: { value: _vm.especialidad_json.anulacion_hora_tlm },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "anulacion_hora_tlm",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(5),
        ]),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.label_video_explicativo,
                      expression: "especialidad_json.label_video_explicativo",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    placeholder: "Ej: Ver video explicativo",
                    type: "text",
                  },
                  domProps: {
                    value: _vm.especialidad_json.label_video_explicativo,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "label_video_explicativo",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(9),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.especialidad_json.url_video_explicativo,
                      expression: "especialidad_json.url_video_explicativo",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "https://...", type: "url" },
                  domProps: {
                    value: _vm.especialidad_json.url_video_explicativo,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.especialidad_json,
                        "url_video_explicativo",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "table",
              { staticClass: "table table-striped table-bordered w-100" },
              [
                _vm._m(12),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.establecimientos_encuestas_asignadas,
                    function (establecimiento) {
                      return _c("tr", { key: establecimiento.id }, [
                        _c("td", [_vm._v(_vm._s(establecimiento.nombre))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(establecimiento.encuestas_maximas)),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: establecimiento.encuestas_asignadas,
                                expression:
                                  "\n                                        establecimiento.encuestas_asignadas\n                                    ",
                              },
                            ],
                            key: establecimiento.id,
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: {
                              value: establecimiento.encuestas_asignadas,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  establecimiento,
                                  "encuestas_asignadas",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ])
                    }
                  ),
                  0
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "hr-line-dashed" }),
        _vm._v(" "),
        _vm.list.length > 0 ? _c("hr") : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "row",
              staticStyle: {
                "border-bottom": "1px solid #bfbfbfee",
                "margin-bottom": "16px",
              },
            },
            [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Establecimiento " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Selecciona establecimiento",
                          label: "nombre",
                          multiple: true,
                          taggable: true,
                          "track-by": "id",
                          options: _vm.establecimientos_list,
                        },
                        model: {
                          value: item.establecimientos,
                          callback: function ($$v) {
                            _vm.$set(item, "establecimientos", $$v)
                          },
                          expression: "item.establecimientos",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Estrategia " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.estrategia,
                            expression: "item.estrategia",
                          },
                        ],
                        staticClass: "custom-select",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              item,
                              "estrategia",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v(
                            "\n                                Seleccione un elemento\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.estrategias_list,
                          function (estrategia, index3) {
                            return _c(
                              "option",
                              {
                                key: index3,
                                domProps: { value: estrategia.id },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(estrategia.nombre) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo Cita " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("multiselect", {
                        attrs: {
                          placeholder: "Selecciona tipo cita",
                          label: "abrev",
                          multiple: true,
                          taggable: true,
                          "track-by": "id",
                          options: _vm.tipo_cita_list,
                        },
                        model: {
                          value: item.tipo_citas,
                          callback: function ($$v) {
                            _vm.$set(item, "tipo_citas", $$v)
                          },
                          expression: "item.tipo_citas",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Eliminar")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: {
                          click: function ($event) {
                            return _vm.eliminar(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fal fa-times" })]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "a",
              { attrs: { href: "javascript:void(0)" }, on: { click: _vm.add } },
              [_vm._v("Añadir Estrategia")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _vm._m(14),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-footer" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 offset-md-8" }, [
          _c(
            "div",
            { staticClass: "btn-group float-right" },
            [
              _c(
                "b-overlay",
                { attrs: { show: _vm.buttonDisable, rounded: "sm" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" },
                      on: { click: _vm.save },
                    },
                    [
                      _c("i", { staticClass: "fal fa-save" }),
                      _vm._v(" Guardar\n                        "),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-barcode" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Confirmable ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content":
              "Permitir realizar la confirmación de las horas de esta especialidad.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-clock" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("div", {
        staticClass: "form-group",
        staticStyle: { display: "none" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "hr-line-dashed" }),
        _vm._v(" "),
        _c("h2", [_vm._v("Video Explicativo")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Etiqueta del video ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content":
              "Texto descriptivo que se mostrará como link en los vouchers.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("URL del video explicativo ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content":
              "Enlace al video explicativo asociado a esta especialidad. Se mostrará en los vouchers de pacientes.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-video" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "hr-line-dashed" }),
        _vm._v(" "),
        _c("h2", [_vm._v("Encuestas Máximas")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Establecimiento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Disponibles")]),
        _vm._v(" "),
        _c("th", [_vm._v("Encuestas Asignadas")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "hr-line-dashed" }),
        _vm._v(" "),
        _c("h2", [_vm._v("Indicaciones Correo")]),
        _vm._v(" "),
        _c("div", { staticClass: "hr-line-dashed" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", {
          staticClass: "dropzone",
          attrs: { id: "dropzoneEspecialidad" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }